module.exports = __webpack_public_path__ + "static/img/pic_xfengm80@2x.5dacfc7e.png";